export const lastTorchGeolocationSelector = ({lastTorchGeolocation}) => lastTorchGeolocation